// Based on: https://github.com/cpulvermacher/time-travel/blob/master/src/scripts/replace_date.ts
// Store original constructors globally to prevent re-initialization issues
let OriginalDate;
let OriginalIntlDateTimeFormat;
let isInitialized = false;
const FAKE_DATE_STORAGE_KEY = 'timeTravelDate';
/**
 * Gets the current fake time in milliseconds since epoch, or undefined if time travel is not active.
 * This is useful for passing the fake time to iframes or other contexts.
 */
export const getCurrentFakeTime = () => {
    const fakeDate = window.sessionStorage.getItem(FAKE_DATE_STORAGE_KEY);
    return fakeDate ? String(new Date(fakeDate).getTime()) : undefined;
};
export const timeTravel = (serverTime) => {
    window.sessionStorage.setItem(FAKE_DATE_STORAGE_KEY, serverTime);
    // Only initialize once to prevent re-override issues
    if (!isInitialized) {
        OriginalDate = window.Date;
        OriginalIntlDateTimeFormat = window.Intl.DateTimeFormat;
        isInitialized = true;
        function maybeFakeNowDate() {
            try {
                const fakeDate = window.sessionStorage.getItem(FAKE_DATE_STORAGE_KEY);
                if (fakeDate) {
                    return new OriginalDate(fakeDate);
                }
            }
            catch (err) {
                // Fall through to return real date
            }
            return new OriginalDate();
        }
        const FakeDate = function (...args) {
            if (args.length === 0) {
                return maybeFakeNowDate();
            }
            return new OriginalDate(...args);
        };
        FakeDate.prototype = OriginalDate.prototype;
        FakeDate.prototype.constructor = FakeDate;
        FakeDate.now = () => maybeFakeNowDate().getTime();
        FakeDate.parse = OriginalDate.parse;
        FakeDate.UTC = OriginalDate.UTC;
        const FakeIntlDateTimeFormat = function (locales, options) {
            const instance = new OriginalIntlDateTimeFormat(locales, options);
            return new Proxy(instance, {
                get(target, prop) {
                    const value = target[prop];
                    // Special handling for format and formatToParts to inject fake date
                    if (prop === 'format' || prop === 'formatToParts') {
                        return function (date) {
                            return target[prop](date ?? maybeFakeNowDate());
                        };
                    }
                    // For other methods, bind them to the target if they're functions
                    if (typeof value === 'function') {
                        return value.bind(target);
                    }
                    return value;
                },
            });
        };
        FakeIntlDateTimeFormat.prototype = OriginalIntlDateTimeFormat.prototype;
        Object.getOwnPropertyNames(OriginalIntlDateTimeFormat).forEach((key) => {
            if (typeof OriginalIntlDateTimeFormat[key] === 'function') {
                FakeIntlDateTimeFormat[key] = OriginalIntlDateTimeFormat[key].bind(OriginalIntlDateTimeFormat);
            }
        });
        window.Date = FakeDate;
        window.Intl.DateTimeFormat = FakeIntlDateTimeFormat;
    }
};
